import { render, staticRenderFns } from "./AdjustTable.vue?vue&type=template&id=3bcafb5a&scoped=true&"
import script from "./AdjustTable.vue?vue&type=script&lang=js&"
export * from "./AdjustTable.vue?vue&type=script&lang=js&"
import style0 from "./AdjustTable.vue?vue&type=style&index=0&id=3bcafb5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcafb5a",
  null
  
)

export default component.exports